import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MatchsCreditBalanceStat')
export class MatchsCreditBalanceStat {

  @JsonProperty('day_timestamp', Number)
  dayTimestamp: number = 0;

  @JsonProperty('gain_count', Number)
  gainCount: number = 0;

  @JsonProperty('spent_count', Number)
  spentCount: number = 0;

  @JsonProperty('balance', Number)
  balance: number = 0;
}
